import "./IconButton.css";

function IconButton({id, className = "validate", type = "button", disabled = false, onClick, onMouseEnter, onMouseLeave, icon, style = {}, title}) {

    return (
        <button id={id} type={type} style={style} className={className} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} disabled={disabled} onClick={onClick} title={title}> <i className={icon} aria-hidden="true"></i></button>
    )
}

export default IconButton;
